import React from 'react';
import {Stack, Typography} from '@mui/material';
import {FileDataDialog, FilesCategoryType, FileTag, ReportType} from '@pages/FilesPage';
import {Dayjs} from 'dayjs';
import {UploadFileItem} from './UploadFileItem';
import {FileType} from '@features/files/types';

type UploadFileListProps = {
    filesData: FileDataDialog[];
    category?: FilesCategoryType | null;
    allTags?: FileTag[];
    handleFilenameChange: (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleDocumentDateChange: (index: number) => (newValue: Dayjs | null) => void;
    handleDeleteFile: (index: number) => () => void;
    handleOpenTagSidebar: (index: number) => void;
    handleDeleteTag: (fileIndex: number, tagId: string) => void;
    isEditing?: boolean;
    handleTypeChange: (index: number) => (newValue: ReportType | null) => void;
    filesType?: FileType;
    showAddTagButton?: boolean;
};

export const UploadFileList = ({
    filesData,
    category,
    handleFilenameChange,
    handleDocumentDateChange,
    handleDeleteFile,
    handleOpenTagSidebar,
    handleDeleteTag,
    isEditing,
    handleTypeChange,
    filesType,
    showAddTagButton = true,
}: UploadFileListProps) => {
    if (filesData.length === 0) {
        return (
            <Typography
                variant='body2'
                color='textSecondary'
            >
                Нет файлов для загрузки
            </Typography>
        );
    }

    return (
        <Stack
            spacing={2}
            width='568px'
        >
            {filesData.map((fileData, index) => (
                <UploadFileItem
                    key={index}
                    index={index}
                    fileData={fileData}
                    onFilenameChange={handleFilenameChange(index)}
                    onDocumentDateChange={handleDocumentDateChange(index)}
                    onDeleteFile={handleDeleteFile(index)}
                    onDeleteTag={(tagId) => handleDeleteTag(index, tagId)}
                    onOpenTagSidebar={() => handleOpenTagSidebar(index)}
                    isEditing={isEditing}
                    onChangeType={(newValue) => handleTypeChange(index)(newValue)}
                    category={category}
                    filesType={filesType}
                    showAddTagButton={showAddTagButton}
                />
            ))}
        </Stack>
    );
};
